package team.platforma.materialextension.moc_data

data class TaskStatus(
    val id: Long,
    val name: String,
)

fun cabinetTasksStatuses() : List<TaskStatus> = listOf(
    TaskStatus(
        id = 1,
        name = "Новые задачи"
    ),
    TaskStatus(
        id = 2,
        name = "Задачи в работе"
    )
)

fun allTasksStatuses() : List<TaskStatus> = listOf(
    TaskStatus(
        id = 4,
        name = "Все"
    ),
    TaskStatus(
        id = 1,
        name = "Новые"
    ),
    TaskStatus(
        id = 2,
        name = "В работе"
    ),
    TaskStatus(
        id = 3,
        name = "Выполненые"
    ),
    TaskStatus(
        id = 5,
        name = "Отклоненные"
    ),
    TaskStatus(
        id = 6,
        name = "Какие-то еще"
    ),
)